export default "__VITE_ASSET__$xHcou7B__"